module.exports = __webpack_public_path__ + "img/4.8848f3cb.png";